import { Box, Typography } from '@mui/material';
import typography from '../../styles/typography.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';
export const Crossover = ({ model, crossover }) => {
    const { t } = useTranslation();
    const crossoverInfo = t(`${model}.crossover`);
    const info =
        t(`${model}.crossover`).localeCompare(`${model}.crossover`) === 0 ||
        crossoverInfo === undefined
            ? crossover
            : crossoverInfo;
    return (
        <Box className={layout.subSectionContainer}>
            <Typography>
                <span className={typography.modelDescriptionSubTitle}>
                    {t('model.cross_over')}:{' '}
                </span>
                <span className={typography.modelDescription}> {info}</span>
            </Typography>
        </Box>
    );
};
